/*! video-dial - v0.0.0 - 2016-01-29
 * Copyright (c) 2016 Birgir Hrafn Sigurðsson, Ewerton Assis, YouGov
 * Licensed under the Apache-2.0 license. */
(function(window, videojs) {
  'use strict';
  var iOSVersion,
      iOS = /iPad|iPhone|iPod/.test(navigator.platform) || (/iPad|iPhone|iPod/.test(navigator.userAgent) && !/Windows/.test(navigator.userAgent)),
      isMobileOrTablet = (function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      })(),
      isChrome = (function() {
        var check = false;
        (function(a) {if(/crios|chrome/gi.test(a))check = true})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      })();
      var androidVersion = null;
      var matchAndroid = navigator.userAgent.match(/Android \d+/i);
      if(matchAndroid && matchAndroid.length > 0) {
        androidVersion = parseInt(matchAndroid[0].split("Android ")[1]);
      }

  if(iOS) {
      iOSVersion = (function(){
          var match = navigator.userAgent.match(/OS (\d+)_/i);
          if (match && match[1]) { return parseInt(match[1]); }
      })()
  }

  var useCanvasVideoPlayer = (iOS && iOSVersion < 10);

  var defaults = {
    dial:{
      hide: false,
      max:100,
      min:0,
      minColor:'#FF0000',
      maxColor:'#00FF00',
      minText:'Minimum',
      maxText:'Maximum'
    },
    marker:{
      maxCount:0
    },
    playText:'Play',
    pauseText:'Pause',
    allowFullscreen:true,
    allowPause:true,
    autoFullscreen:false,
    autoPlay:false,
    fullwindowText:'Toggle Fullscreen',
    dialchange: function(value, timestamp) {console.warn('The dialchange callback has not been set');},
    dialmarker: function(timestamp) {console.warn('The dialmarker callback has not been set');}
    };

  var settings,
      videoPlayer,
      canvasVideo,
      videoDial,
      resizeTimer,
      isTrackingMouse,
      playercontainer,
      playercontainerWidth;

  var fullWindowResize = function() {
    var player = videoPlayer;
    try {
      var current_player;
      if(typeof(player.id) === 'function')
        current_player = $('#'+player.id())
      else
        current_player = $('#'+player.id)

      if(current_player.hasClass('vjs-full-window')){
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(fullwindow, 300);
      }
    }catch(err) {
      console.warn('fullWindowResize failed because of error :');
      console.log(err);
    }
  }

  var fullwindow = function(){
    var player,
        icon = $('#touchPlayBtn').find('.fa');
    if(isMobileOrTablet) {
      playercontainer = $('#player');
      playercontainer.addClass('vjs-full-window').addClass('vjs-full-window-touch');
      if (icon.hasClass('fa-pause')) $('#touchPlayBtn').hide();
    }
    if(useCanvasVideoPlayer) {
      player = canvasVideo;
      player.id = 'canvasplayer';
      playercontainer.addClass('vjs-full-window-iphone');
      $('.video-js-canvas-overlay').show();
    } else {
      player = videoPlayer;
    }
    // 'this' is the player
    // var container = $('#'+player.id());
    var container;
    if(typeof(player.id) === 'function')
      container = $('#'+player.id())
    else
      container = $('#'+player.id)

    container.addClass('vjs-full-window');

    var videoHeight, orientation, style

    if(useCanvasVideoPlayer) {
      // Fix the dial to the bottom of the screen
      videoDial = playercontainer.find('#video-dial').addClass('fixed')
      orientation = (window.screen.height > window.screen.width) ? "portrait" : "landscape";

      if(orientation === "landscape") {
        // Calculate a height for the video in fullscreen
        // note : we can't use 100% because we need to compensate for the dial
        videoHeight = $(window).height() - videoDial[0].clientHeight;

        // Use inline 'style' attribute because the height in fullwindow to overwrite !importand
        style = "height:"+ videoHeight + "px !important;width: 100%;";
      } else {
        style = "height: auto !important;width: 100%;";
      }
    } else {
      // Fix the dial to the bottom of the screen
      videoDial = container.find('#video-dial').addClass('fixed')

      // Set fullwindow css class definitions to the video
      var tech = container.find('.vjs-tech');
      tech.addClass('vjs-fullscreen')
      tech.addClass('video-js')
      tech.addClass('vjs-full-window')

      // Calculate a height for the video in fullscreen
      // note : we can't use 100% because we need to compensate for the dial
      videoHeight = $(window).height() - videoDial[0].clientHeight;
      
      // Use inline 'style' attribute because the height in fullwindow to overwrite !importand
      style = "height:"+ videoHeight + "px !important;";

      tech.attr('style', style)
    }

    // Add a global keyup listener that leaves exits the window when the keyboard is pressed
    $(document).on('keyup.video-dial', player.leaveFullWindow)

    $('.video-js > .btn-dial-fullwindow i').removeClass('fa-expand').addClass('fa-compress')
    $('.video-js > .btn-dial-fullwindow').css('bottom', ($('#video-dial').height() + 35) + 'px');
    $('.vjs-play-control').hide();
    $('#touchPlayBtn').css('bottom', '48%').show();
  }

  var toggleFullwindowButton = function(e){
    var player;
    if(useCanvasVideoPlayer) {
      player = canvasVideo;
      player.id = 'canvasplayer';
    } else {
      player = videoPlayer;
    }
    // Is the video fullscreen ?
    var current_player;
    if(typeof(player.id) === 'function')
      current_player = $('#'+player.id())
    else
      current_player = $('#'+player.id)

    if(current_player.hasClass('vjs-full-window')){
      exitFullwindowButton(e);
    }else{
      if (!e.isTrigger || e.isTrigger === undefined) {
        // If our device supports the fullscreen API (Chrome, Android, etc)
        // and our user initiated it, use it for a better fullscreen UI
        // https://stackoverflow.com/a/29282049
        if (document.documentElement.requestFullscreen && typeof document.documentElement.requestFullscreen === 'function') {
          document.documentElement.requestFullscreen();
        }
      }
      fullwindow.call(player);
    }
  }

  var exitFullwindowButton = function(e){
    e.which = 27; // `escape` key
    leaveFullWindow(e);
    e.stopPropagation();
  }

  //
  var leaveFullWindow = function(e){
    if ((window.fullScreen || document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement)
        && document.exitFullscreen && typeof document.exitFullscreen === 'function') {
      document.exitFullscreen();
    }
    if(isMobileOrTablet) playercontainer.removeClass('vjs-full-window').removeClass('vjs-full-window-touch');
    if(useCanvasVideoPlayer) {
      var container = $('#canvasplayer');
      container.height(playercontainer.height());
      container.width(playercontainer.width());
      playercontainer.removeClass('vjs-full-window-iphone');
      $('.video-js-canvas-overlay').hide();
      setCanvasAndDialDimensions()
    } else {
      // Because I can't know where the 'focus' is when the keyboard is pressed,
      // I assume that there can only be one video-js in fullscreen at a time.
      // That's why I can simply do a global lookup for the .vjs-full-window class
      var container = $('.vjs-full-window').parents('.video-js');
    }
    
    // '27' is the 'escape' key on the keybard
    if(e.which == 27){
      container.removeClass('vjs-full-window')
      container.find('.canvas').removeClass('vjs-full-window')
      container.find('.vjs-tech').removeClass('vjs-fullscreen')
      container.find('.vjs-tech').removeClass('vjs-full-window')
      container.find('.vjs-tech').removeClass('video-js')
      $('#video-dial').removeClass('fixed')
      container.find('.vjs-tech').css('height', '' )
    }

    // If ANY KEY is pressed and there is not a fullwindow video on the screen
    // THEN Unbind THIS event from being triggered whith every keyup
    if($('.vjs-full-window').length==0){
      $(document).off('keyup.video-dial')
    }

    if(isMobileOrTablet) {
      playercontainerWidth = ($(window).width() <= 520) ? ($(window).width() - 20) : 520
      $('#player').css({'max-width': playercontainerWidth + 'px', 'width': '100%'})
    }
    $('.video-js > .btn-dial-fullwindow i').removeClass('fa-compress').addClass('fa-expand')
    $('#touchPlayBtn').css('bottom', '35%');
    $('.video-js > .btn-dial-fullwindow').css('bottom', '15px');
  }

  var unbindEvents = function(container){
    // Unbind all events owned by video-dial by it's event namespace
    container.off('.video-dial');
    $(window).off('resize.video-dial');
    stopMouseTracking();
  }

  // This event is triggered BEFORE the player.dispose method
  var dispose = function(e){
    var container = $(e.target).parents('.video-js');
    unbindEvents(container);
  }

  var hideVideoPlayerWhenErr = function() {
    $('.video-js').css({'background': 'transparent', 'width': '100%'});
    $('.video-js-canvas-wrapper, .video-js video, .vjs-loading-spinner').hide();

    // Set status and dial input values based on error state
    var $object = window.Gryphon.widgets.VideoDial._object,
        dialInput = $('#r-' + $object.input_id),
        statusInput = $('#r-' + $object.status_input);

    setTimeout(function() {
      dialInput.val('0:-3');
      if(statusInput.val() !== 3) statusInput.val(3);
    });
  }

  var videoEnded = function(e){
    var container

    if(useCanvasVideoPlayer) {
      container = $('#videoplayer')
      if(canvasVideo) document.getElementById(canvasVideo.canvas.id).removeEventListener('touchstart', onStart, false)
    } else {
      container = $(e.target).parents('.video-js')
    }

    // Hide the slider
    container.find('#video-dial .ui-slider-handle').css('display', 'none');
    container.find('#video-dial .marker').css('display', 'none');

    // Leave fullwindow (if it's on)
    if(container.hasClass('vjs-full-window') || container.find('.canvas').hasClass('vjs-full-window')){
      leaveFullWindow({which:27}); // 27 is the 'escape' key
    }

    // Hide video buttons (fullscreen, play/pause)
    $('#touchPlayBtn, .btn-dial-fullwindow').hide()

    if(isMobileOrTablet) {
      if(!$('#mainNav').is(':visible')) $('#mainNav').show()
    }

    if(e && e.type === 'error') {
      // Special Error Handling :: (iOS<8, unsupported video formats and devices)
      var error_msg = null;
      try {
        if(typeof window.data.player.error === 'function' &&
           window.data.player.error().code &&
           window.data.player.error().code == 4) {
          var object = window.Gryphon.widgets.VideoDial._object
          var sources = object.player.sources.filter(
            source => source.src !== player.currentSrc()
          )
          if (!sources || sources.length === 0) {
            // MediaError :: https://developer.mozilla.org/en-US/docs/Web/API/MediaError
            error_msg = "Sorry, no compatible source and playback technology were found for this video."+
                        " Try using another browser like <a href=\"http://bit.ly/ccMUEC\" target=\"_blank\">Chrome</a> or"+
                        " download the latest <a href=\"http://adobe.ly/mwfN1\" target=\"_blank\">Adobe Flash Player</a>.";
            $('#videoplayer').prepend('<div class="error-message" style="position: absolute; top: 25%; left: 0px;">'+
                                      error_msg+'</div>');
            hideVideoPlayerWhenErr();
          }
        }
      } catch(e) {}

      if(iOS && iOSVersion <= 7) {
        // Note :: we cannot support iOS < 8 at this time
        error_msg = "Your device cannot support the features of this survey question.\n"+
                    "You may try updating your device's software.";
        $('#videoplayer').prepend('<div class="error-message" style="position: absolute; top: 25%; left: 0px;">'+
                                  error_msg+'</div>');
        hideVideoPlayerWhenErr();
      }
    }

    setTimeout(function() {
      if (localStorage && settings.plays && (localStorage.getItem('plays_'+settings.element_id) >= settings.plays)) {
        // In the event our auto advance is not working, we want to stop the mouse tracking that records data
        stopMouseTracking();
      }
    });
  }

  // The video-dial adds a margin to it's parent container to compensate for
  // it's height because the video-dial is displayed just outside of the
  // video-js container div.
  var addMarginToVideoJSContainer = function(dial){
    dial.parents('.video-js').css('margin-bottom', dial.height() + 30)
  }

  var toggleMarkerVisibility = function(data, player){
    var marker = data.marker || window.data.marker;
    if(marker!==''){
      var maxCount = data.settings.marker.maxCount;
      var markerCounter = parseInt(data.dial.attr('dialmarker-counter'));

      // If it's reached the maxCounter then we disable the marker and return
      if((maxCount!==0)&&(maxCount <= markerCounter +1 )){
        marker.find('button.btn-dial-marker').attr('disabled', "disabled")
        return;
      }

      if(useCanvasVideoPlayer) {
        if(!player.playing) marker.find('button.btn-dial-marker').attr('disabled', 'disabled').addClass('noselect')
        else marker.find('button.btn-dial-marker').removeAttr('disabled').removeClass('noselect')
      }
      else {
        if(player.paused()) marker.find('button.btn-dial-marker').attr('disabled', 'disabled').addClass('noselect')
        else marker.find('button.btn-dial-marker').removeAttr('disabled').removeClass('noselect')
      }
    }
  }

  // This event is bound/unbound when the play/pause is clicked
  var mousemove = function (e) {
    var player = videoPlayer

    if(player.isTouchMoveMarker) {
      player.isTouchMoveMarker=false
      e.stopPropagation()
      return false;
    }

    var slider = e.data.slider,
        widthPx = slider.width(),
        cursorPos = e.clientX - slider.offset().left,
        ratio =  cursorPos / widthPx

    // Calulate the new position
    var newValue = e.data.settings.dial.max * ratio
    if(newValue < e.data.settings.dial.min) newValue = e.data.settings.dial.min
    else if(newValue > e.data.settings.dial.max) newValue = e.data.settings.dial.max

    newValue = Math.round(newValue)
    // Change the value on the slider
    e.data.slider.slider('value', newValue)
    e.data.settings.dialchange(newValue , e.data.player.currentTime())
  }

  var disableSlider = function(e){
    var handle = $('.ui-slider-handle');
    if(iOS) {
      if((iOSVersion < 10 && canvasVideo && !canvasVideo.playing) || (iOSVersion >= 10 && e.data.player && e.data.player.paused())) {
        e.stopPropagation();
        return false;
      } else {
        handle.css('opacity', 0.3);
      }
    } else {
      if(e.data.player.paused()) {
        e.stopPropagation();
        return false;
      } else if (isMobileOrTablet) {
        handle.css('opacity', 0.3);
      }
    }
  }

  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) { func.apply(context, args); }
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) { func.apply(context, args); }
    };
  }

  function startMouseTracking() {
    isTrackingMouse = true;
    $(document).on('mousemove.video-dial', null, window.data, mousemove);
  }

  function stopMouseTracking() {
    isTrackingMouse = false;
    $(document).off('mousemove.video-dial');
  }

  function toggleMouseTracking() {
      if (isTrackingMouse) stopMouseTracking();
      else startMouseTracking();
  }

  var markerClick = function(e){
    if(!!!$(this).attr('disabled')){
      var markerCounter = e.data.dial.attr('dialmarker-counter');
      if(typeof(markerCounter) !== 'undefined'){
        markerCounter = parseInt(markerCounter, 10);
      }
      else{
        markerCounter = 0;
      }
      var maxCount = e.data.settings.marker.maxCount;
      if((maxCount!==0)&&(maxCount <= markerCounter+1)){
        $(this).prop('disabled', true);
        $(this).attr('disabled', 'disabled');
        $(this).text(e.data.settings.marker.disabledText);
      }
      e.data.dial.attr('dialmarker-counter', markerCounter + 1);

      if(typeof(e.data.settings.dialmarker) === 'function'){
        var timestamp = e.data.player.currentTime();
        e.data.settings.dialmarker.call(this, timestamp);
      }
      e.stopPropagation();
    }
  }

  var tapTimer, tapHold;
  var onStart = debounce(function (event) {
    var player,
        icon = $('#touchPlayBtn').find('.fa'),
        handle = $('.ui-slider-handle');

    if(useCanvasVideoPlayer) {
      player = canvasVideo;
      if (player.playing && window.data.settings.allowPause) {
        player.pausedByUser = true

        if(isChrome && iOSVersion >= 10) player.video.pause(); // for Chrome iOS

        player.pause();
        $('#touchPlayBtn').fadeIn('fast');
        icon.removeClass('fa-pause').addClass('fa-play');
        handle.addClass('paused').removeClass('playing');
      } else {
        player.pausedByUser = false

        // for Chrome iOS
        var toggleIconInt;
        if(isChrome && iOSVersion >= 10 && player.video.readyState < 2) {
          var conf = confirm('Begin video playback?');
          if(conf) {
            player.video.play();
            setTimeout(function() {
              player.video.pause();
            });

            toggleIconInt = setInterval(function() {
              if($('#touchPlayBtn').is(':visible')) {
                $('#touchPlayBtn').hide();
                clearInterval(toggleIconInt);
              }
            }, 300);
          }
        }

        player.play();
        $('#touchPlayBtn').hide();
        if(window.data.settings.allowPause) {
          icon.removeClass('fa-play').addClass('fa-pause');
          handle.addClass('playing').removeClass('paused');
        }
      }
    } else {
      player = videoPlayer;
      if(player.paused()) {
        player.play();
        if(isMobileOrTablet) {
          if($(player.el_).hasClass('vjs-full-window')) { $('#touchPlayBtn').hide(); }
        }
        else {
          startMouseTracking();
        }
        if(window.data.settings.allowPause) {
          icon.removeClass('fa-play').addClass('fa-pause');
          handle.addClass('playing').removeClass('paused');
          $('#touchPlayBtn').fadeOut('fast');
        } else {
          $('#touchPlayBtn').hide();
        }
      } else {
        if(window.data.settings.allowPause) {
          player.pause();
          if(window.data.settings.allowPause) {
            icon.removeClass('fa-pause').addClass('fa-play');
            handle.addClass('paused').removeClass('playing');
            $('#touchPlayBtn').fadeIn('fast');
          }
          stopMouseTracking();
        }
      }
    }
    toggleMarkerVisibility(window.data, player)
  }, 200);

  var onSlide = debounce(function (event, ui) {
    var player = videoPlayer,
        icon = $('#touchPlayBtn').find('.fa'),
        slider = window.data.slider,
        newValue;

    // If the video is playing AND you did not touch the tooltip (nor circle)
    if(((player && !player.paused()) || (canvasVideo && canvasVideo.playing)) && !$(event.target).hasClass('tooltips') && !$(event.target).hasClass('btn-dial-marker')) {
      player.isTouchMove = true
      if(canvasVideo) canvasVideo.isTouchMove = true

      // Set the new value
      newValue = ui.value;
      if(newValue < window.data.settings.dial.min) newValue = window.data.settings.dial.min;
      else if(newValue > window.data.settings.dial.max) newValue = window.data.settings.dial.max;

      window.data.settings.dialchange(newValue, window.data.player.currentTime())
    } else {
      player.isTouchMove = true
      if(canvasVideo) {
        canvasVideo.isTouchMove = true
        toggleMarkerVisibility(window.data, canvasVideo)
      }
    }
  }, 200);

  var onSlideStop = debounce(function (event, ui) {
    if (isMobileOrTablet) {
      var handle = $('.ui-slider-handle');
      handle.css('opacity', 1);
    }
  }, 100);

  var onTouchEnd = debounce(function (event) {
    clearTimeout(tapTimer);
    if(!tapHold) onStart(event);

    // reset our tap & hold flag
    tapHold = false;
  }, 100);

  var onTouchStart = debounce(function (event) {
    tapTimer = setTimeout(function() {
      tapHold = true;
    }, 300);
  }, 100);

  var setCanvasAndDialDimensions = function() {
    setTimeout(function() {
      var orientation = (window.screen.height > window.screen.width) ? "portrait" : "landscape";
      if(orientation === 'landscape' || $('#player').width() > $('canvas').width() && $('canvas').width() > 0) {
        // Orientation :: Landscape
        // set the dial element's container to
        // the width of the canvas element
        if(($(window).height() - 160) < 300) $('canvas').height($(window).height() - 160)
        else $('canvas').height(300)
        $('canvas').width($('canvas').height() * 1.7)

        $('#player').width($('canvas').width())
        $('#player').height($('canvas').height())
        $('#video-dial').css('top', $('canvas').height() + 'px')
      } else {
        // Orientation :: Portrait
        // set the canvas width/height
        $('canvas').width($('#player').width())
        $('canvas').height($('canvas').width() / 1.7)

        $('#player').height($('canvas').height())
        $('#video-dial').css('top', $('canvas').height() + 'px')
      }
    })
  }

  /**
   * Initialize the plugin.
   * @param options (optional) {object} configuration for the plugin
   */
  videoDial = function(options) {
    var player = this;
    var containerId;// = player.id();

    videoPlayer = player;
    
    if(typeof(player.id) === 'function')
      containerId = player.id();
    else
      containerId = player.id;

    var container = $('#'+containerId);
    var dial = $('<div>').attr('id', 'video-dial').toggle(!options.dial.hide);
    if(typeof(options)==='undefined'){
      options={};
    }

    var passive_opts = false;

    try {
      if (window._supportsPassive) {
        passive_opts = {passive: true};
      }
    } catch (e) {}

    // Merge options into defaults and return a new dict
    settings = $.extend(true, {}, defaults, options);

    // Dynamic setting of dial.value
    if(typeof(settings.dial.value)==='undefined'){
      settings.dial.value = settings.dial.max / 2;
    }

    // Dynamic setting of marker.disabledText
    if(typeof(settings.marker.text)!=='undefined'){
      if(typeof(settings.marker.disabledText)==='undefined'){
        settings.marker.disabledText = settings.marker.text;
      }
    }
    var slider = $('<div>').addClass('video-dial-slider')
                           .addClass('gradient')
                           .addClass('noselect')
                           .attr('video-id',containerId)
                           .slider(settings.dial);

    // Change the gradient of the slider (dial)
    if(settings.dial.minColor.toLowerCase() !== 'white' &&
       settings.dial.maxColor.toLowerCase() !== 'white' &&
       settings.dial.minColor.toLowerCase() !== '#ffffff' &&
       settings.dial.maxColor.toLowerCase() !== '#ffffff') {
      // no murky colors in the middle if none of our specified colors are white
      slider.css("background", "linear-gradient(to right, "+settings.dial.minColor+" 0%,#FFFFFF 50%,"+settings.dial.maxColor+" 100%)")
            .css("background", "-webkit-linear-gradient(left, "+settings.dial.minColor+" 0%,#FFFFFF 50%,"+settings.dial.maxColor+" 100%)")
            .css("background", "-o-linear-gradient(left, "+settings.dial.minColor+" 0%,#FFFFFF 50%,"+settings.dial.maxColor+" 100%)")
            .css("background", "-moz-linear-gradient(left, "+settings.dial.minColor+" 0%,#FFFFFF 50%,"+settings.dial.maxColor+" 100%)")
            .css("filter", "progid:DXImageTransform.Microsoft.gradient(startColorstr='"+settings.dial.minColor+"',endColorstr='"+settings.dial.maxColor+"',GradientType=1)");
    } else {
      // if one is white, then just do a straight linear gradient like normal
      slider.css("background", "linear-gradient(to right, "+settings.dial.minColor+" 0%,"+settings.dial.maxColor+" 100%)")
            .css("background", "-webkit-linear-gradient(left, "+settings.dial.minColor+" 0%,"+settings.dial.maxColor+" 100%)")
            .css("background", "-o-linear-gradient(left, "+settings.dial.minColor+" 0%,"+settings.dial.maxColor+" 100%)")
            .css("background", "-moz-linear-gradient(left, "+settings.dial.minColor+" 0%,"+settings.dial.maxColor+" 100%)")
            .css("filter", "progid:DXImageTransform.Microsoft.gradient(startColorstr='"+settings.dial.minColor+"',endColorstr='"+settings.dial.maxColor+"',GradientType=1)");
    }

    // Add center/left/right marks to the video dial slider
    slider.prepend('<div class="left-line"></div><div class="center-line"></div><div class="right-line"></div>')

    // Add the tooltip to the slider
    var handle = slider.find('.ui-slider-handle');
    handle.addClass('tooltips').css({'left': 'calc(50% + 0.1em)'});

    // Create a min/max elements
    var maxmin = $('<div>').attr('class', 'minmax noselect');
    var min = $('<span>').attr('class', 'min noselect');
    var max = $('<span>').attr('class', 'max noselect');

    min.append($('<span class="content noselect">'+settings.dial.minText+'</span>'));
    max.append($('<span class="content noselect">'+settings.dial.maxText+'</span>'));

    maxmin.append(min);
    maxmin.append(max);

    // Create the 'marker' button
    var marker = $('<div>').attr('class', 'marker noselect');
    var button = $('<button>').attr('type', 'button')
                              .attr('disabled', 'disabled')
                              .attr('class', 'btn btn-dial-marker noselect')
                              .text(settings.marker.text);

    if(typeof(settings.marker.color) !== 'undefined' && typeof(settings.marker.color) === 'string') {
      button.css({'background-image': 'none', 'background-color': settings.marker.color, 'border-color': 'transparent'});
    }

    var touchPlayBtn;
    if(!settings.autoPlay ||
       (typeof settings.autoPlay === "string" && settings.autoPlay.toLowerCase() === 'false') ||
       settings.autoPlay === 0) {
      touchPlayBtn = $('<div><i class="fa fa-play"></i></div>').attr('id', 'touchPlayBtn');
    } else {
      touchPlayBtn = $('<div><i class="fa fa-play"></i></div>').attr('id', 'touchPlayBtn').css('display', 'none');
    }
    var toggleFullscreen = $('<button>').attr('type', 'button')
                                        .attr('class', 'btn btn-dial-fullwindow noselect')
                                        .html('<i class="fa fa-expand"></i>');

    if(typeof(settings.marker.text) !== 'undefined'){
      marker.append(button);
    }
    if(settings.allowFullscreen === true || settings.allowFullscreen === 1){
      container.prepend(toggleFullscreen);
    }

    // Create Data object that's parsed into the events so they don't have to
    // do lookups
    var data = window.data = {settings:settings,
                player:player,
                dial:dial,
                slider:slider,
                marker:marker,
                container:container,
                handleSpan:handle.find('span')};

    // Bind events
    // Event :: Enable the dialchange by clicking the slider or tooltip
    var id = container.attr('id')

    // Event :: Disable the slider if the video is paused
    slider.on('slidestart.video-dial', null, data, disableSlider);
    slider.on('slide.video-dial', null, data, onSlide);
    slider.on('slidestop.video-dial', null, data, onSlideStop);

    // Event :: Click the marker button
    button.on('click.video-dial', null, data, markerClick);
    button.on('mousedown.video-dial', null, null, function(e){ e.stopPropagation(); });
    if(iOS) {
      button.on('mousedown.video-dial', null, data, markerClick);
    }

    // Event :: Toggle fullscreen
    toggleFullscreen.on('click.video-dial', toggleFullwindowButton);
    if(settings.autoFullscreen ||
      (typeof settings.autoFullscreen === "string" && settings.autoFullscreen.toLowerCase() === "true")) {
      var fullScreenIconCheck = setInterval(function() {
        if (toggleFullscreen.length > 0) {
          clearInterval(fullScreenIconCheck);
          setTimeout(function() {
            if(iOS && iOSVersion <= 7) { /* Feature not implemented for iOS7 and below */ }
            else { toggleFullscreen.click() }
          });
        }
      });
    }

    // Event :: Disable the video-dial when it ends or errors
    player.on("ended", videoEnded);
    player.on("error", videoEnded);

    // Event :: Hook onto the players dispose method
    player.on("dispose", dispose);

    player.on("pause", function() {
      $('#touchPlayBtn, button.btn-dial-fullwindow').fadeIn('fast');
    });

    // Event for first play only to track user-initiated events (iOS>9)
    player.one("play", function (event) {
      // Hide the native video control after initial load/start
      if(iOS && iOSVersion >= 10) {
        $('.vjs-play-control').hide();

        var handle = $('.ui-slider-handle');
        handle.addClass('playing').removeClass('paused');
      }
    });

    player.tech.userActivity_ = true;
    player.tech.reportUserActivity = function(event){
      player.tech.userActivity_ = true;
    };
    player.tech.userActive_ = true;
    player.tech.userActive = function(bool){
      if (bool !== undefined) {
        bool = !!bool;
        if (bool !== player.tech.userActive_) {
          player.tech.userActive_ = bool;
          if (bool) {
            player.tech.userActivity_ = true;
            player.tech.removeClass('vjs-user-inactive');
            player.tech.addClass('vjs-user-active');
            player.tech.trigger('userActiveOverVideo');
          } else {
            player.tech.userActivity_ = false;

            player.tech.one('mousemove', function(e){
              e.stopPropagation();
              e.preventDefault();
            });
            player.tech.removeClass('vjs-user-active');
            player.tech.addClass('vjs-user-inactive');
            player.tech.trigger('userInactiveOverVideo');
          }
        }
        return player.tech;
      }
      return player.tech.userActive_;
    };

    player.tech.listenForUserActivity = function() {
      var onMouseActivity,
          activityCheck, inactivityTimeout;

      onMouseActivity = player.tech.reportUserActivity;

      player.tech.on('mousemove', onMouseActivity);

      activityCheck = setInterval(function() {
        // Check to see if mouse/touch activity has happened
        if (player.tech.userActivity_) {
          // Reset the activity tracker
          player.tech.userActivity_ = false;

          // If the user state was inactive, set the state to active
          player.tech.userActive(true);

          // Clear any existing inactivity timeout to start the timer over
          clearTimeout(inactivityTimeout);

          // In X seconds, if no more activity has occurred the user will be
          // considered inactive
          inactivityTimeout = setTimeout(function() {
            // Protect against the case where the inactivityTimeout can trigger just
            // before the next user activity is picked up by the activityCheck loop
            // causing a flicker
            if (!player.tech.userActivity_) {
              player.tech.userActive(false);
            }
          }, 1000);
        }
      }, 250);

      // Clean up the intervals when we kill the player
      player.tech.on('dispose', function(){
        clearInterval(activityCheck);
        clearTimeout(inactivityTimeout);
      });
    };
    if(!isMobileOrTablet) {
      player.tech.listenForUserActivity();
    }

    player.tech.on("userActiveOverVideo", function(event) {
      if(!isMobileOrTablet &&
         $('video.vjs-tech').hasClass('vjs-user-active') &&
         $('div.video-js').hasClass('vjs-playing')) {
        $('button.btn-dial-fullwindow').fadeIn('fast');
      }
    });
    player.tech.on("userInactiveOverVideo", function() {
      if(!isMobileOrTablet &&
         $('video.vjs-tech').hasClass('vjs-user-inactive') &&
         $('div.video-js').hasClass('vjs-playing')) {
        $('#touchPlayBtn, button.btn-dial-fullwindow').fadeOut('fast');
      }
    });

    // Event :: Fix the fullscreen on resize
    $(window).on('resize.video-dial', fullWindowResize);

    // Event :: Listen for orientation changes on mobile/tablet
    window.addEventListener("orientationchange", function() {
      setTimeout(function() {
        if(useCanvasVideoPlayer) setCanvasAndDialDimensions()
        if($('.vjs-full-window').length > 0) $('.video-js > .btn-dial-fullwindow').css('bottom', ($('#video-dial').height() + 55) + 'px')
        else $('.video-js > .btn-dial-fullwindow').css('bottom', '15px')
      })
    }, false);

    // Method :: FullWindow.
    //  note  :: Overwrites videojs's `enterFullWindow` and `requestFullScreen`
    player.fullwindow = fullwindow;
    player.fullscreen = fullwindow;
    player.enterFullWindow = fullwindow;
    player.requestFullScreen = fullwindow;

    // Method :: Exits the fullwindow environment
    player.leaveFullWindow = leaveFullWindow;

    // Append the elements to the video container
    dial.append(slider);
    dial.append(maxmin);
    // If either the marker button or the toggle fullwindow are available, append the marker
    if((typeof(settings.marker.text) !== 'undefined')
    || (settings.allowFullscreen==true)){
      dial.append(marker);
    }
    container.append(dial);
    addMarginToVideoJSContainer(dial);

    var checkLoading;
    checkLoading = setInterval(function() {
      try {
        if((iOS && iOSVersion <= 7) || (window.data.player && window.data.player.error())) {
          clearInterval(checkLoading);
          window.data.player.trigger('error');
        } else if(window.data.player && window.data.player.currentSrc() && !window.data.player.error()) {
          clearInterval(checkLoading);
          container.prepend(touchPlayBtn)
          if(!isMobileOrTablet) { $('div.video-js video, #touchPlayBtn, .ui-slider-handle').on('click', onStart); }
          else {
            if((matchAndroid && androidVersion >= 4) || isChrome) {
              $('div.video-js video, #touchPlayBtn').on('click', onStart);
              document.querySelector('.ui-slider-handle').addEventListener('touchstart', onTouchStart, passive_opts);
              document.querySelector('.ui-slider-handle').addEventListener('touchend', onTouchEnd, passive_opts);
            } else {
              if (iOS && iOSVersion >= 10) {
                $('div.video-js video, #touchPlayBtn').on('click', onStart);
                $('.vjs-control-bar').show().css({
                  top: '0',
                  bottom: 'auto'
                });
                $('.vjs-play-control').css({
                  top: (($('div.video-js video').height()/2) - $('.vjs-control-bar').height()) + 'px'
                });
                $('#touchPlayBtn').hide(); // use native video player's play icon for playback initially
              }
              document.querySelector('.ui-slider-handle').addEventListener('touchstart', onTouchStart, passive_opts);
              document.querySelector('.ui-slider-handle').addEventListener('touchend', onTouchEnd, passive_opts);
            }
          }

          // auto-play once video is loaded into DOM
          if(settings.autoPlay ||
             (typeof settings.autoPlay === "string" && settings.autoPlay.toLowerCase() === "true")) {
            var delay = isMobileOrTablet ? 4000 : 1500;
            setTimeout(function() {
              if(!isMobileOrTablet) touchPlayBtn.click();
              /**
               * NOTE: This will be deprecated in a future Chrome release to allow Android devices to
               * call video event like 'play' without specific user interaction.
               *
               * Performing operations that require explicit user interaction on touchstart events is deprecated and
               * will be removed in M56, around January 2017. See https://www.chromestatus.com/features/5649871251963904
               * for more details.
               */
              // else if(!iOS) $('#touchPlayBtn').trigger('touchstart');
            }, delay);
          }
        }
      } catch(e) {
        if(window.player && window.player.trigger) {
          window.player.trigger({type:'error', message: e});
        }
      }
    }, 500);

    // Event :: Raise a flag if the user touches (on a tablet or phone) the are below the
    //          slider. This is to prevent the user from touching that area and the dial
    //          enterpreting that as a click on the handle (circle and tooltip).
    //  Note :: This is bound AFTER the dial has been added to the DOM because the dial is
    //          generated using jquery and 'touchstart' is not supported by the jquery version
    //          that is required for the dial.
    var videoInDOM = document.getElementById(containerId)

    // if addEventListener does not exist we are in IE8 < (Not a touch device)
    if(videoInDOM.addEventListener){
      if(isMobileOrTablet) {
        playercontainerWidth = ($(window).width() <= 520) ? ($(window).width() - 20) : 520
        $('#player').css({'max-width': playercontainerWidth + 'px', 'width': '100%'})
        $('.tooltips span').hide(); // hide the play/pause button on touch devices
      }
    }

    if(useCanvasVideoPlayer) {
      if(iOSVersion >= 8) {
        $('.video-js-canvas-wrapper').show()
        var autoPlay = false;
        try {
          if(typeof settings.autoPlay === 'string') {
            // string
            autoPlay = settings.autoPlay.toLowerCase();
          } else if(typeof settings.autoPlay === 'number' && settings.autoPlay === 1) {
            // number
            autoPlay = true;
          } else {
            // boolean
            autoPlay = settings.autoPlay;
          }
        } catch(e) {}
        canvasVideo = new CanvasVideoPlayer({
          videoSelector: '.video-js video',
          canvasSelector: '.video-js-canvas',
          audio: '#audioplayer',
          autoplay: autoPlay
        });
        canvasVideo.pausedByUser = true;
        $('.video-js-canvas').show();
        $('.video-js').css({'background': 'transparent', 'width': '100%'});
        $('.video-js video').attr('muted', 'muted');
        document.getElementById(canvasVideo.canvas.id).addEventListener('touchstart', onStart, passive_opts);

        if(canvasVideo && canvasVideo.video) {
          canvasVideo.video.addEventListener('timeupdate', function (e) {
            if(!canvasVideo.playing && !canvasVideo.pausedByUser) {
                player.trigger('ended')
            }
          }, passive_opts)
        }

        setCanvasAndDialDimensions();
      }
    }
  };

  // register the plugin
  videojs.plugin('videoDial', videoDial);
})(window, window.videojs);